import { Alert } from "react-bootstrap";

const RestrictedUserSummary = ({ userData }) => {
  // Early return if restrictedUser or branchDetails is null or undefined
  if (
    !userData ||
    !userData.restrictedUser ||
    userData.branchDetails === null
  ) {
    return null;
  }

  // calculations to prevent unnecessary re-renders
  const summaryCounts =
    userData.branchDetails?.length === 0
      ? { branchCount: 0, regionCount: 0, atmCount: 0, regionSet: new Set() }
      : userData.branchDetails?.reduce(
          (acc, cur) => ({
            branchCount: acc.branchCount + 1,
            regionCount: acc.regionSet.has(cur.region)
              ? acc.regionCount
              : acc.regionCount + 1,
            atmCount: acc.atmCount + (cur.devices?.length || 0),
            regionSet: new Set([...acc.regionSet, cur.region]),
          }),
          {
            branchCount: 0,
            regionCount: 0,
            atmCount: 0,
            regionSet: new Set(),
          }
        );
  const { branchCount, regionCount, atmCount } = summaryCounts || {};

  // Helper function for pluralization
  const pluralize = (count, singular, plural) =>
    count === 1 ? singular : plural;

  if (branchCount === 0) {
    return (
      <Alert variant={"warning"} role="status" aria-live="polite">
        <i className="fa fa-info-circle" aria-hidden="true" /> {"\t"}
        You don’t have any branch or ATM access yet.
      </Alert>
    );
  } else {
    return (
      <Alert variant={"warning"} role="status" aria-live="polite">
        <i className="fa fa-info-circle" aria-hidden="true" /> {"\t"}
        You have access to{" "}
        <strong>
          {branchCount} branch{pluralize(branchCount, "", "es")}
        </strong>{" "}
        across{" "}
        <strong>
          {regionCount} region{pluralize(regionCount, "", "s")}
        </strong>{" "}
        with{" "}
        <strong>
          {atmCount} ATM{pluralize(atmCount, "", "s")}
        </strong>
        .
      </Alert>
    );
  }
};

export default RestrictedUserSummary;
